import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const VWModel = ({ header, children, isOpen, showFooter, handleClose, modalSize, className }) => {
  const [sizeClassName, setSizeClassName] = useState('');

  useEffect(() => {
    const baseClassName = 'modal';
    switch (modalSize) {
      case 'small':
        setSizeClassName(` ${baseClassName}-sm`);
        break;
      case 'large':
        setSizeClassName(` ${baseClassName}-lg`);
        break;
      case 'extra-large':
        setSizeClassName(` ${baseClassName}-xl`);
        break;
      case 'xxl':
        setSizeClassName(` ${baseClassName}-xxl`);
        break;
      default:
        setSizeClassName(` ${baseClassName}-custom-width`);
    }
  }, [modalSize]);

  const renderClassName = (modalSize, className) => {
    if (className) {
      return `${sizeClassName} ${className}`;
    }
    return `${sizeClassName}`;
  };

  return (
    <Modal isOpen={isOpen} className={renderClassName(modalSize, className)} autoFocus={false}>
      <ModalHeader toggle={handleClose}>{header}</ModalHeader>
      <ModalBody>{children}</ModalBody>
      {showFooter && <ModalFooter></ModalFooter>}
    </Modal>
  );
}

export default VWModel;
